@if(!confirm) {
  <h2 mat-dialog-title>{{ 'orders.duplicateInAnotherJurisdiction' | transloco: { type: getOrderType() } }}</h2>
  <mat-dialog-content>
    <div class="flex-container">
      <mat-form-field class="flex-item form-field" appearance="outline">
        <mat-label>{{ 'common.labels.jurisdiction' | transloco }}</mat-label>
        <mat-select name="jurisdiction" [(ngModel)]="selectedJurisdiction"
          (selectionChange)="handleJurisdictionChangeEvent()">
          @for (jurisdiction of jurisdictions; track jurisdiction) {
            <mat-option [value]="jurisdiction.jurisdictionCode">
              {{jurisdiction.jurisdictionFullName}}
            </mat-option>
          }
        </mat-select>
      </mat-form-field>
    </div>
    @if (showQcFormTypeControl()) {
      <div class="flex-container">
        <mat-form-field class="flex-item form-field" appearance="outline">
          <mat-label>{{ 'common.labels.formType' | transloco }}</mat-label>
          <mat-select name="qc-from-type" [(ngModel)]="selectedQcForm">
            @for (qcFormType of qcFormTypes; track qcFormType) {
              <mat-option [value]="qcFormType.value">
                {{qcFormType.label}}
              </mat-option>
            }
          </mat-select>
        </mat-form-field>
      </div>
    }
    @if (_userGroups.length > 1) {
      <div class="flex-container">
        <mat-form-field appearance="outline" class="flex-item form-field">
          <mat-label>{{ 'orders.requestFor' | transloco }}</mat-label>
          <mat-select name="user-group"  [(ngModel)]="selectedUserGroup">
            @for (userGroup of _userGroups; track userGroup) {
              <mat-option [value]="userGroup.value">
                {{userGroup.label}}
              </mat-option>
            }
          </mat-select>
        </mat-form-field>
      </div>
    }
  </mat-dialog-content>
} @else {
  <mat-dialog-content>
    <div class="flex-container">{{ 'orders.areYouSureYouWantTo2' | transloco }}</div>
  </mat-dialog-content>
}
<mat-dialog-actions align="end">
  <button mat-raised-button [mat-dialog-close]="true">{{ 'common.buttons.cancel' | transloco }}</button>
  <button mat-raised-button [disabled]="shouldDisableDuplicateButton()" color="primary" (click)="onDuplicateClick()">{{ (confirm ? 'common.buttons.yes' : 'orders.duplicate') | transloco }}</button>
</mat-dialog-actions>
